import { Injectable } from '@angular/core';
import { WritableSignal, signal } from '@angular/core';
import {TableRow, TableColumn} from '../../../shared/models/components/tables/table.models';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {   ProjectData } from '../../models/serviceModels/request/modelDefinitionsReq.model';
import {   projectInputsByModelResponse } from '../../models/serviceModels/response/model-definitions-response.models';
import {modelAccuracyResponse} from '../../models/serviceModels/response/model-accuracy-response.model';
import { ModelAccuracyModel } from '../../models/serviceModels/request/modelAccuracyReq.model';

@Injectable({
    providedIn: 'root'
  })
  export class ModelAccuracyService {

    predictionRange: Date[] | null = null;
    exclusionDateRanges: { start: Date, end: Date }[] = [];

    constructor(private apiService: ApiService) { }


    getModelAccuracy(modelAccuracyModel: ModelAccuracyModel): Observable<modelAccuracyResponse> {
       return this.apiService.post('api/Data/GetModelAccuracy', modelAccuracyModel);
      }
    
    setCurrentPredictionRange(dates: Date[] | null) {
        this.predictionRange = dates;
    }

    getCurrentPredictionRange(): Date[] | null {
        return this.predictionRange;
    }

    setExclusionDateRanges(ranges: { start: Date, end: Date }[]) {
        this.exclusionDateRanges = ranges;
    }

    getExclusionDateRanges(): { start: Date, end: Date }[] {
        return this.exclusionDateRanges;
    }
    
  }